import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import { Form, Select, Icon, Spin } from 'antd';
import { dadataSearchBank, dadataSetBank } from '../actions';
import './dadata.css';
const FormItem = Form.Item;
const Option = Select.Option;

const fetchingIcon = <Icon type="loading" spin />;

class DadataSearchBank extends Component {
  constructor(props) {
    super(props);

    this.fetchSearchResults = debounce(this.fetchSearchResults, 800);

    this.state = {
      isActive: true,
      value: '',
      suggestions: [],
      fetching: false,
      validateStatus: '',
      searchError: '',
    };
  }

  fetchSearchResults = value => {
    const { dadataSearchBank } = this.props;
    if (value.length > 3) {
      this.setState({
        fetching: true,
      });
      dadataSearchBank(value);
    } else {
      this.setState({
        fetching: false,
      });
    }
  };

  onAutoSearchChange = value => {
    let { result, handleChange } = this.props;
    if (value) {
      const { dadataSetBank } = this.props;
      let name = value.split(',')[0].trim();
      let bic = value.split(',')[1].trim();

      let selectedVal = result.filter(
        option => option.value === name && option.data.bic === bic
      );
      this.setState({
        value: name,
        validateStatus: 'success',
      });
      dadataSetBank(selectedVal[0]);
      if (handleChange) handleChange(selectedVal[0]);
    }
  };

  render() {
    const { status, error, result } = this.props;
    const { fetching, value } = this.state;
    return (
      <FormItem
        label={this.props.label ? this.props.label : null}
        className="organization"
        hasFeedback
        //Вот с этим кодом ниже не уверен. Возможно надо переделать иначе.
        validateStatus={status !== 'IDLE' ? status : ''}
        help={error}
      >
        <Select
          id="dadataSearchBank"
          value={value}
          showSearch
          showArrow={false}
          allowClear={true}
          notFoundContent={
            fetching ? <Spin indicator={fetchingIcon} size="small" /> : null
          }
          filterOption={false}
          suggestions={result}
          placeholder="Наименование или БИК"
          onSearch={this.fetchSearchResults}
          onChange={this.onAutoSearchChange}
          getPopupContainer={trigger => trigger.parentNode}
          className={`${
            value ? 'notDadataPlaceholder dadataSearch' : 'dadataSearch'
          } `}
          style={this.props.style ? this.props.style : null}
        >
          {result &&
            result.map(s => (
              <Option key={`${s.value}, ${s.data.bic}`}>
                <span
                  style={{
                    display: 'block',
                    fontSize: '14px',
                    textTransform: 'uppercase',
                    color: '#323232',
                    letterSpacing: '-0.7px',
                  }}
                >
                  {s.value}
                </span>
                <span
                  style={{
                    display: 'block',
                    color: '#9b9b9b',
                    fontSize: '14px',
                    letterSpacing: '-0.7px',
                  }}
                >
                  {s.data.bic}, {s.data.address.value}
                </span>
              </Option>
            ))}
        </Select>
      </FormItem>
    );
  }
}

export default connect(
  state => ({
    result: state.Customers.dadataBank.result,
    status: state.Customers.dadataBank.status,
  }),
  { dadataSearchBank, dadataSetBank }
)(DadataSearchBank);
